import Home from '../views/Home.vue'
import overview from "../views/warehouseAdmin/overview"
import inventory from "../views/nurse/inventory"
import inbound from "../views/warehouseAdmin/Inbound"
import outbound from "../views/nurse/outbound"
import Invitations from "../views/nurse/invitations"
import account from "../views/public/account"
import password from "../views/public/password"
import discounts from "../views/warehouseAdmin/discounts"
import boxsizes from "../views/warehouseAdmin/boxsizes"
import payments from "../views/warehouseAdmin/payments"
import bank from "../views/public/bank"
import transferCheck from "../views/warehouseAdmin/transferCheck"
import serviceFeeConfig from "../views/warehouseAdmin/serviceFeeConfig";

let warehouseAdminRouter = [
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-inbox',
        leaf: true,//只有一个节点
        children: [
            {path: '/inbound', component: inbound, name: 'Inbound'}
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-product-hunt',
        leaf: true,//只有一个节点
        children: [
            {path: '/inventory', component: inventory, name: 'Inventory'}
        ]
    },  {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-outdent',
        leaf: true,//只有一个节点
        children: [
            {path: '/outbound', component: outbound, name: 'Outbound'}
        ]
    },  {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-credit-card',
        leaf: true,//只有一个节点
        children: [
            {path: '/payments', component: payments, name: 'Payment'}
        ]
    },   {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-paper-plane',
        leaf: true,//只有一个节点
        children: [
            {path: '/transferCheck', component: transferCheck, name: 'Transfers'}
        ]
    },   {
        path: '/',
        component: Home,
        name: 'Settings',
        iconCls: 'fa fa-cog',
        children: [
            {path: '/account',iconCls: 'fa fa-user', component: account, name: 'Account'},
            {path: '/password',iconCls: 'fa fa-key', component: password, name: 'Password'},
            {path: '/bank', iconCls: 'fa fa-credit-card-alt',component: bank, name: 'Bank'},
            {path: '/invitations',iconCls: 'fa fa-handshake-o', component: Invitations, name: 'Invitations'},
            {path: '/discounts',iconCls: 'fa fa-dollar', component: discounts, name: 'Discounts'},
            {path: '/boxsizes',iconCls: 'fa fa-dollar', component: boxsizes, name: 'Category Set'},
            {path: '/serviceFee',iconCls: 'fa fa-dollar', component: serviceFeeConfig, name: 'Service Fee Set'},
        ]
    }];

export default warehouseAdminRouter;





// WEBPACK FOOTER //
// ./src/router/warehouseAdminRouter.js